// components/LayoutWithBanner.jsx
import React from 'react';
import { Box, styled } from '@mui/material';

const LayoutContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '99.5vh',
  display: 'flex',
  flexDirection: 'column',
  // backgroundColor: 'red',
  [theme.breakpoints.between('md', '1076')]: {
    minHeight: '97.8vh',
  },
}));

const ContentSection = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
  // background: theme.palette.mode === "dark" ? '#1A1B1F' : '#4487B0',
  padding: theme.spacing(2, 6, 0, 4),

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 3, 3, 3),
  },
  // backgroundColor: 'purple',
}));

const LayoutWithBanner = ({ children, userInfo }) => {
  return (
    <LayoutContainer>
      <ContentSection>{children}</ContentSection>
    </LayoutContainer>
  );
};

export default LayoutWithBanner;

// const [hasBanner, setHasBanner] = useState(false);
//   const [currentBannerType, setCurrentBannerType] = useState(null);
//   const [scrollY, setScrollY] = useState(0);
//   const theme = useTheme();
//   const mdUp = useMediaQuery(theme.breakpoints.up('md'));
//   const lgUp = useMediaQuery(theme.breakpoints.up('lg')); // For desktop (≥1200px)

//   // Check if banner should be shown based on userInfo
//   useEffect(() => {
//     const bannerType = getBannerType(userInfo);
//     const bannerShouldShow = shouldShowBanner(userInfo);

//     setCurrentBannerType(bannerType);
//     setHasBanner(bannerShouldShow);
//   }, [userInfo]);

//   // Add a periodic check to catch banner transitions
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const bannerType = getBannerType(userInfo);
//       const bannerShouldShow = shouldShowBanner(userInfo);

//       // Only update if there's actually a change
//       if (bannerType !== currentBannerType) {
//         setCurrentBannerType(bannerType);
//         setHasBanner(bannerShouldShow);
//       }
//     }, 100); // Check every 100ms for smooth transitions

//     return () => clearInterval(interval);
//   }, [userInfo, currentBannerType]);

//   // Handle banner close - but don't permanently disable banners
//   const handleBannerClose = () => {
//     // Force a small delay then recheck what banner should show
//     setTimeout(() => {
//       const bannerType = getBannerType(userInfo);
//       const bannerShouldShow = shouldShowBanner(userInfo);

//       setCurrentBannerType(bannerType);
//       setHasBanner(bannerShouldShow);
//     }, 50);
//   };

//   // Handle scroll events
//   useEffect(() => {
//     const handleScroll = () => {
//       setScrollY(window.scrollY);
//     };

//     window.addEventListener('scroll', handleScroll, { passive: true });
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // ============================================================
//   // ORIGINAL CODE - WILL BE RESTORED AFTER DECEMBER 2024
//   // ============================================================
//   // Update CSS custom properties based on scroll and banner state
//   // useEffect(() => {
//   //   if (!mdUp || !hasBanner) {
//   //     // Reset to default values when no banner or on mobile
//   //     document.documentElement.style.setProperty('--sidebar-top', '0px');
//   //     document.documentElement.style.setProperty('--sidebar-height', '100vh');
//   //     return;
//   //   }

//   //   const bannerHeight = 40; // Banner height in pixels

//   //   // Calculate how much of the banner is still visible
//   //   const visibleBannerHeight = Math.max(0, bannerHeight - scrollY);

//   //   // Update CSS custom properties
//   //   document.documentElement.style.setProperty(
//   //     '--sidebar-top',
//   //     `${visibleBannerHeight}px`
//   //   );
//   //   document.documentElement.style.setProperty(
//   //     '--sidebar-height',
//   //     `calc(100vh - ${visibleBannerHeight}px)`
//   //   );
//   // }, [scrollY, hasBanner, mdUp]);
//   // ============================================================

//   // ============================================================
//   // TEMPORARY CODE FOR DECEMBER 2024 - CHRISTMAS BANNER
//   // TO REVERT: Uncomment original code above and remove this section
//   // ============================================================
//   // Update CSS custom properties based on scroll and banner state
//   useEffect(() => {
//     // Mobile: no sidebar adjustment needed
//     if (!mdUp) {
//       document.documentElement.style.setProperty('--sidebar-top', '0px');
//       document.documentElement.style.setProperty('--sidebar-height', '100vh');
//       return;
//     }

//     // Christmas banner heights (always visible in December)
//     const christmasBannerHeight = lgUp ? 58 : 64.27; // Desktop : Tablet

//     // Normal banner height (conditional - only if hasBanner is true)
//     const normalBannerHeight = hasBanner ? 40 : 0;

//     // Total banner height
//     const totalBannerHeight = christmasBannerHeight + normalBannerHeight;

//     // Calculate visible banner height based on scroll
//     const visibleBannerHeight = Math.max(0, totalBannerHeight - scrollY);

//     // Update CSS custom properties
//     // document.documentElement.style.setProperty(
//     //   '--sidebar-top',
//     //   `${visibleBannerHeight}px`
//     // );
//     // document.documentElement.style.setProperty(
//     //   '--sidebar-height',
//     //   `calc(100vh - ${visibleBannerHeight}px)`
//     // );
//   }, [scrollY, hasBanner, mdUp, lgUp]);
//   // ============================================================

//   // Cleanup CSS custom properties on unmount
//   useEffect(() => {
//     return () => {
//       document.documentElement.style.removeProperty('--sidebar-top');
//       document.documentElement.style.removeProperty('--sidebar-height');
//     };
//   }, []);
